<template>
  <b-container>
    <h1>{{ $t("fuelStock.create") }}</h1>
    <success-fade-alert ref="alert" :msg="$t('fuelStock.createSuccess')" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <FuelStockCreateMovementCrud
          ref="crudData"
          :model="model"
          :modelstate="modelstate"
        />
      </b-col>
    </b-row>

    <!-- {{ model }} -->
    <b-button @click="save()" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
  <script>
export default {
  name: "FuelStockCreateMovement",
  components: {
    FuelStockCreateMovementCrud: () =>
      import(
        "@/components_rms/fuelSupplies/fuelStock/FuelStockCreateMovementCrud.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  computed: {
    getUrlBackToList() {
      return `../fuelStock/list`;
    },
  },
  data() {
    return {
      alert: {
        error: "",
        success: this.$t("fuelStock.createSuccess"),
      },
      submitted: false,
      model: {
        movementType: "",
        datetimeMovement: null,
        fuelTypeId: null,
        liters: 0.0,
        valuePerLiter: 0.0,
        totalValue: 0.0,
        fuelSupplyOriginId: null,
      },
      modelstate: {},
    };
  },
  methods: {
    save() {
      this.submitted = true;

      const apiModel = {
        movementType: this.model.movementType,
        datetimeMovement: this.model.datetimeMovement,
        fuelTypeId: this.model.fuelTypeId,
        liters: this.model.liters,
        valuePerLiter: this.model.valuePerLiter,
        totalValue: this.model.totalValue,
        fuelSupplyOriginId: this.model.fuelSupplyOriginId,
      };

      this.$apiVehicle
        .post("/fuelStockMovement/new/", apiModel)
        .then((response) => {
          this.modelstate = {};
          this.cleanModel();
          this.submitted = false;
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    cleanModel() {
      this.model = {
        movementType: "",
        datetimeMovement: null,
        fuelTypeId: null,
        liters: 0.0,
        valuePerLiter: 0.0,
        totalValue: 0.0,
        fuelSupplyOriginId: null,
      };
    },
  },
};
</script>
  